module.exports = __webpack_public_path__ + "img/专家标题.a4eef33f.jpg";